var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24471 0C5.3336 0 6.31426 0.463428 7.00021 1.20381C7.68616 0.463428 8.66681 0 9.75571 0C11.847 0 13.1801 2.16368 12.3444 4H17C18.6569 4 20 5.34315 20 7V15C20 16.6569 18.6569 18 17 18H3C1.34315 18 0 16.6569 0 15V7C0 5.77464 0.734652 4.72087 1.78753 4.25511C0.69738 2.37068 2.05563 0 4.24471 0ZM3.9664 4H6.00021V3.7555C6.00021 2.78597 5.21424 2 4.24471 2C3.59411 2 3.19225 2.70975 3.52698 3.26764L3.9664 4ZM8.00021 4H10.034L10.4734 3.26764C10.8082 2.70975 10.4063 2 9.75571 2C8.78617 2 8.00021 2.78597 8.00021 3.7555V4ZM8 6V8H18V7C18 6.44772 17.5523 6 17 6H8ZM6 6H3C2.44772 6 2 6.44772 2 7V8H6V6ZM2 11H6V16H3C2.44772 16 2 15.5523 2 15V11ZM18 11H8V16H17C17.5523 16 18 15.5523 18 15V11Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg);
export default __webpack_public_path__ + "static/media/card_img.6eaa448faa89a47fb10313bf30e3717c.svg";
export { ForwardRef as ReactComponent };